import React from 'react';

import { type MenuItem, type MenuItemKey } from '../../Dashboard';
import Item from './Item/Item';
import styles from './Menu.style';

type MenuProps = {
  items: MenuItem[];
  selectedItem: MenuItemKey;
  onItemClick: (item: MenuItemKey) => void;
};

const Menu: React.FC<MenuProps> = ({ items, selectedItem, onItemClick }) => {
  return (
    <div style={styles.container}>
      <div style={styles.menu}>
        {items.map((item) => (
          <Item
            key={item.key}
            label={item.label}
            icon={item.icon}
            active={item.key === selectedItem}
            disabled={item.disabled}
            onClick={() => onItemClick(item.key)}
          />
        ))}
      </div>
    </div>
  );
};

export default Menu;
